import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import setMailListFocusInfo from 'mini-mail-list-store/lib/actions/setMailListFocusInfo';
import { action } from 'satcheljs/lib/legacy';
import { ActionMessage } from 'satcheljs';
import { getItemIdToExpandForSearch } from 'mini-mail-list-store/lib/utils/getItemIdToExpandForSearch';
import { getListViewTypeCustomData } from 'mini-mail-list-store/lib/selectors/getListViewTypeCustomData';
import { getStore } from 'owa-mail-store/lib/store/Store';
import { getSubject } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { lazyPrefetchAdjacentItemsOnDelay } from 'mini-mail-prefetch';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import {
    lazyLoadConversationReadingPane,
    lazyLoadItemReadingPane,
} from 'mini-mail-reading-pane-loader';

export default action('singleSelectMailItem', {
    datapoint: {
        name: 'LoadMailConversation' /* loadMailConversationDatapoint */,
        options: { isCore: true },
    },
})(function singleSelectMailItem(
    rowId: string,
    inputRowSubject?: string
): Promise<void | ActionMessage> {
    const mailStore = getStore();
    const tableView = getSelectedTableView();
    const rowSubject = inputRowSubject || getSubject(rowId);

    mailStore.mailModule.selectedId = rowId;
    mailStore.mailModule.selectedSubject = rowSubject;

    // Set this item as the current focused row in the mail list so that
    // when we come back to list view, focus directly goes to this item
    setMailListFocusInfo(tableView, {
        focusedRowId: rowId,
    });

    addCustomPropertiesInDataPoint();

    // lazy load the data for adjacent rows for improved reading pane load
    lazyPrefetchAdjacentItemsOnDelay.importAndExecute(rowId, tableView);

    // lazy load reading pane
    if (isItemView()) {
        return lazyLoadItemReadingPane.importAndExecute(rowId, false /* shouldLogDataPoint */);
    } else {
        // Get conversation node to expand in case of search
        const initiallySelectedItemId = getItemIdToExpandForSearch(rowId) || null;
        return lazyLoadConversationReadingPane.importAndExecute(rowId, initiallySelectedItemId);
    }
});

const addCustomPropertiesInDataPoint = () => {
    const tableView = getSelectedTableView();

    // Add the folder name as custom data
    const datapoint = returnTopExecutingActionDatapoint();
    const folderName =
        tableView &&
        tableView.tableQuery &&
        tableView.tableQuery.folderId &&
        folderIdToName(tableView.tableQuery.folderId);

    datapoint.addCustomData({
        Folder: !folderName || folderName === 'none' ? 'CustomFolder' : folderName,
        ...getListViewTypeCustomData(),
    });
};
